import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs,Switch } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ActionForm from '../components/ActionForm';
import TriggerForm from '../components/TriggerForm';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class TriggersList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    action_triggers: [],
    datarequested:true,

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/action_triggers/?action_workflow_mapping=${this.props.mapping_obj.id}`)
  .then(res => {
      this.setState({
        action_triggers:res.data
      })
      this.setState({datarequested:false})
  })

}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {
    const columns = [
    
      {
        title: 'Outcome',
        dataIndex: 'outcome',
        key: 'id',
        ...this.getColumnSearchProps('outcome'),
      },
     
      {
        title: 'Triggered Action',
        dataIndex: 'action_name',
        key: 'id',
        ...this.getColumnSearchProps('action_name'),
      },
      {
        title: 'Condition',
        dataIndex: 'condition',
        key: 'id',
      },

      {
        title: 'Auto Prompt Applicant?',
        dataIndex: 'is_auto_prompt',
        key: 'id',
        render: (text,record) =>
          <p>
            {record.is_auto_prompt===true?"Yes":"No"}
          </p>
      },

      {
        title: 'Prompt fields',
        dataIndex: 'auto_prompted_fields',
        key: 'id',
        render: (text,record) =>
          <p>
            {record.auto_prompted_fields}
          </p>
      },

      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
        <Popover content={<p>Click here to delete </p>} title="Delete">
        <Popconfirm title="Sure to delete?" 
         onConfirm={() =>{
            axios.delete(`${serverconfig.backendserverurl}/api/action_triggers/${record.id}`).then(res =>{
              this.comp_reloaded()
            });
        }}>
          <DeleteOutlined style={{color:'red'}}/>
         </Popconfirm>
        </Popover>

        </p>,
      }
    
     
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
             <TabPane tab={"Triggers"} key="1">
              <p>There are {this.state.action_triggers.length} Triggers in the list </p>
                <Table 
                  columns={columns} 
                  scroll={{ x: 1000 }}
                  pagination={{showQuickJumper:true,showSizeChanger:true }}
                  dataSource={this.state.action_triggers}
                  bordered
               />
              </TabPane>

              <TabPane tab={"New Trigger"} key="2">
                <TriggerForm 
                  onRefresh={this.comp_reloaded}
                  mapping_obj={this.props.mapping_obj}
                />
              </TabPane>

              </Tabs>

        </div>)
    }
  }
}

export default TriggersList; 
